import { toast } from 'react-toastify';

export function showErrorToastMsg(message) {
    toast.error(message, {hideProgressBar: true});
}

export function showSuccessToastMsg(message) {
    toast.success(message, {hideProgressBar: true});
}